var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComponent20745(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_207_45",
    "data-name": "Component 207 \\u2013 45",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_106",
    "data-name": "Path 106",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31 35.5 L 5 35.5 C 2.51869010925293 35.5 0.5 33.4813117980957 0.5 31 L 0.5 5 C 0.5 2.51869010925293 2.51869010925293 0.5 5 0.5 L 31 0.5 C 33.4813117980957 0.5 35.5 2.51869010925293 35.5 5 L 35.5 31 C 35.5 33.4813117980957 33.4813117980957 35.5 31 35.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 1 C 2.794391632080078 1 1 2.794391632080078 1 5 L 1 31 C 1 33.20560836791992 2.794391632080078 35 5 35 L 31 35 C 33.20560836791992 35 35 33.20560836791992 35 31 L 35 5 C 35 2.794391632080078 33.20560836791992 1 31 1 L 5 1 M 5 0 L 31 0 C 33.76142120361328 0 36 2.238571166992188 36 5 L 36 31 C 36 33.76142120361328 33.76142120361328 36 31 36 L 5 36 C 2.238571166992188 36 0 33.76142120361328 0 31 L 0 5 C 0 2.238571166992188 2.238571166992188 0 5 0 Z",
    stroke: "none",
    fill: "#3d2993"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5329",
    "data-name": "Group 5329",
    transform: "translate(-1121 -675)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1060",
    "data-name": "Rectangle 1060",
    width: 24,
    height: 24,
    transform: "translate(1127 681)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5334",
    "data-name": "Group 5334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5342",
    "data-name": "Group 5342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "delete_FILL0_wght400_GRAD0_opsz40",
    d: "M4.529,14.249a1.077,1.077,0,0,1-.789-.331,1.1,1.1,0,0,1-.331-.806V3.732h-.7V2.6H5.971v-.56h4.342V2.6h3.257V3.732h-.7v9.381a1.106,1.106,0,0,1-.331.8,1.063,1.063,0,0,1-.789.339ZM11.756,3.732H4.529v9.381h7.226ZM6.192,11.688h1.12V5.14H6.192Zm2.782,0h1.12V5.14H8.974ZM4.529,3.732v0Z",
    transform: "translate(1130.857 684.857)",
    fill: "#402899"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent20745);
export default __webpack_public_path__ + "static/media/Component 207 – 45.38f79e180b3f62144a39f7cec62d876c.svg";
export { ForwardRef as ReactComponent };